var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5192_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6822 17.1312L12.5301 3.01142C12.1064 2.27749 11.3474 1.83936 10.5 1.83936C9.65256 1.83936 8.89361 2.27753 8.46988 3.01142L0.3178 17.1312C-0.105933 17.8652 -0.105933 18.7415 0.3178 19.4754C0.741533 20.2093 1.50045 20.6475 2.34791 20.6475H18.6521C19.4995 20.6475 20.2585 20.2093 20.6822 19.4754C21.1059 18.7415 21.1059 17.8652 20.6822 17.1312ZM19.6158 18.8597C19.4146 19.2081 19.0544 19.4161 18.6521 19.4161H2.34791C1.94563 19.4161 1.58535 19.2081 1.38421 18.8597C1.18307 18.5113 1.18307 18.0953 1.38421 17.7469L9.53629 3.62707C9.73747 3.27868 10.0977 3.07069 10.5 3.07069C10.9023 3.07069 11.2626 3.27868 11.4637 3.62707L19.6158 17.7469C19.817 18.0953 19.817 18.5113 19.6158 18.8597Z",
    fill: "#BC1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.3115C10.0474 15.3115 9.67908 15.6798 9.67908 16.1325C9.67908 16.5851 10.0474 16.9534 10.5 16.9534C10.9527 16.9534 11.3209 16.5851 11.3209 16.1325C11.3209 15.6798 10.9527 15.3115 10.5 15.3115Z",
    fill: "#BC1823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1157 7.71826H9.88428V14.0804H11.1157V7.71826Z",
    fill: "#BC1823"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5192_13463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.743652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleIcon);
export default __webpack_public_path__ + "static/media/error-triangle-icon.7c12aaf370a99888fa792f4a8fb4cd2d.svg";
export { ForwardRef as ReactComponent };